import classNames from 'classnames';
import { solveModeLabel } from 'components/dashboard/Dashboard.helper';
import { FC, PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { SolvingModeDetail } from 'state/quotes/details/details.model';
export const SolveModeLabel: FC<
  PropsWithChildren<{
    value: SolvingModeDetail;
    size: 'small' | 'normal';
  }>
> = ({ value, size = 'normal' }) => {
  const { formatMessage } = useIntl();
  const solveModeText = useMemo(() => solveModeLabel(value, formatMessage), [value, formatMessage]);

  return (
    <span
      className={classNames('fw-semibold align-text-bottom', {
        'text-large': size === 'small',
        'text-xlarge': size === 'normal',
      })}
    >
      {solveModeText}
    </span>
  );
};

SolveModeLabel.displayName = 'SolveModeLabel';
